import { apiClient } from "@apis/apiClient";
import type { ApiResponse, LogErrorParams } from "./errorBoundaryClient.dto";

/**
 * Error Boundary API Client
 *
 * Provides methods for logging errors.
 */
const errorBoundaryClient = {
  /**
   * Log an error to the error boundary endpoint
   * @param params - Error parameters to log
   * @returns API response
   */
  logError(params: LogErrorParams): Promise<ApiResponse<unknown>> {
    return apiClient.post(`/rest/error_boundary`, params);
  },
};

export { errorBoundaryClient };
export default errorBoundaryClient;
